import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FilterWithMapper from '../FilterWithMapper/FilterWithMapper';
import { fraudMapper } from '../../../Fraud/Fraud';

export default class FraudFilter extends Component {
    static propTypes = {
        disabled: PropTypes.bool,
        filter: PropTypes.any,
        onChange: PropTypes.func
    };

    render() {
        return (
            <FilterWithMapper
                disabled={this.props.disabled}
                filter={this.props.filter}
                mapper={fraudMapper}
                onChange={this.props.onChange}
            />
        );
    }
}
